import {createSelector} from 'reselect';
import {pathOr} from 'ramda';

import {ApplicationStoreType} from 'reducers';
import {SelectorType} from 'constants/flow/flowTypes';

import {ItemV2Type} from '../../reducers/itemV2/itemV2';
import {MODULE_KEY} from '../../../constants';

/**
 * Return cart item v2
 *
 * @param {ApplicationStoreType} store - redux store
 * @returns {ItemV2Type} cart item
 */
export const getItemV2 = (store: ApplicationStoreType): ItemV2Type => store[MODULE_KEY].itemV2;

/**
 * Returns cart item product identifier.
 * @type {SelectorType<number>}
 */
export const getProductIdV2: SelectorType<number> = createSelector(
    getItemV2,
    pathOr(0, ['item', 'product', 'id']),
);

/**
 * Returns quote item identifier.
 * @type {SelectorType<number>}
 */
export const getQuoteItemIdV2: SelectorType<number> = createSelector(
    getItemV2,
    pathOr(0, ['item', 'id']),
);

/**
 * Returns quote item prescription name.
 * @type {SelectorType<string>}
 */
export const getQuoteItemV2PrescriptionName: SelectorType<string> = createSelector(
    getItemV2,
    pathOr('', ['item', 'prescription', 'name']),
);
